import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import moment from "moment";
import { datetimeFormatter } from "../../../utils/datetimeFormatter";
import "leaflet.markercluster";

export const FixedZero = (props) => {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [rowData, setRowData] = useState(null);
  const initialHeight = window.innerHeight - 150;

  const getCellStyle = (params) => {
    var style = {};
    style["cursor"] = "default";
    return style;
  };

  useEffect(() => {
    if (
      props.data.irradiance_fixed_zero !== null &&
      props.data.irradiance_fixed_zero !== undefined
    ) {
      setRowData(props.data.irradiance_fixed_zero);
    }
  }, [props.data]);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  return (
    <div>
      {props.data.irradiance_fixed_zero === null ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Select a data point from the map to see input data
        </div>
      ) : (
        <div>
          <div style={{ padding: 20 }}>
            <h3 style={{ marginTop: 5 }}>Irradiance Fixed Zero</h3>
            <div>Latitude: {props.data.lat}</div>
            <div style={{ marginBottom: 20 }}>Longitude: {props.data.lng}</div>
            <div
              style={{
                height: initialHeight,
                width: "100%",
              }}
              className="ag-theme-balham"
            >
              <AgGridReact
                defaultColDef={{
                  filter: true,
                  filterParams: { buttons: ["reset"] },
                  sortable: true,
                  resizable: true,
                  minWidth: 20,
                  flex: 1,
                  cellStyle: getCellStyle,
                }}
                getContextMenuItems={(params) => [
                  "copy",
                  "copyWithHeaders",
                  "paste",
                  "separator",
                  {
                    name: "Export",
                    icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
                    subMenu: [
                      "csvExport",
                      {
                        name: "Excel Export (.xlsx)",
                        icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                        action: () => {
                          params.api.exportDataAsExcel({ sheetName: "Export" });
                        },
                      },
                    ],
                  },
                ]}
                rowData={rowData}
                rowHeight={24}
                popupParent={document.body}
                suppressDragLeaveHidesColumns={true}
                enableRangeSelection={true}
                onGridReady={onGridReady}
              >
                <AgGridColumn
                  field="datetime"
                  headerName="Datetime"
                  valueFormatter={datetimeFormatter}
                />
                <AgGridColumn
                  field="irradiance_fixed_zero"
                  headerName="Irradiance fixed zero"
                  filter={"agNumberColumnFilter"}
                  type={"numericColumn"}
                />
              </AgGridReact>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(FixedZero);
